export default __webpack_public_path__ + "static/media/657.ccf2998e.png";